import axiosInstance from "./instance";

const axiosService = axiosInstance();

const accessToken = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
export const token = accessToken;

const id = sessionStorage.getItem("id") || localStorage.getItem("id");
export const userId = id;

export const handleuploadprofile = async (profiledatafiled) => {
  try {
    const response = await axiosService.post(`users/profile-details`, profiledatafiled);
    console.log("post details responce-->", response);
    return response;
  } catch (error) {
    console.log("upload error-->", error);
    return error;
  }
}

export const handelsearchapi = async (userdata, page, size) => {
  console.log("Data before search ==>", userdata);
  const currentId = sessionStorage.getItem("id") || localStorage.getItem("id");
  const response = await axiosService.post(`master-data/adv-search/${currentId}?page=${page}&size=${size}`, userdata);
  return response;
}

export const updateHomeProfileDetails = async (userdata) => {
  console.log("Data before search ==>", userdata);
  try {
    const response = await axiosService.put(`/users/profile-details/${userdata.id}`, userdata);
    console.log("put details responce-->", response);
    return response;
  } catch (error) {
    console.log("upload error-->", error);
    return error;
  }
}

export const handelsearch = async (country, university, name, intake, page, size) => {
  try {
    const currentId = sessionStorage.getItem("id") || localStorage.getItem("id");
    const queryParams = `country=${country || ''}&university=${university || ''}&name=${name || ''}&intakes=${intake || ''}`;
    const response = await axiosService.get(`master-data/search/${currentId}?${queryParams}&page=${page}&size=${size}`);
    console.log("Response:", response);
    return response;
  } catch (error) {
    console.error("Error during API request:", error);
    throw error;
  }
};

export const handledownloadthefile = async (file) => {
  const currentId = sessionStorage.getItem("id") || localStorage.getItem("id");
  const response = handleApiRequestAfterLogin(
    "GET",
    API_BASE_URL,
    `${currentId}/user-profile/download/${file}`,
    null
  );
  return response;
}

export const workexperience = async (data) => {
  try {
    const response = await axiosService.post(`users/workexperience`, data);
    console.log("post jobdetails responce-->", response);
    return response;
  } catch (error) {
    console.log("upload error-->", error);
    return error;
  }
}

export const requestResetPassword = async (data) => {
  try {
    const response = await axiosService.post(`/reset-password/request-password-reset`, data);
    console.log("reset password response-->", response);
    return response;
  } catch (error) {
    console.log("reset password error-->", error);
    return error;
  }
}

export const validateResetPassword = async (data) => {
  try {
    const response = await axiosService.post(`/reset-password/reset-password`, data);
    console.log("validate password response-->", response);
    return response;
  } catch (error) {
    console.log("validate password error-->", error);
    return error;
  }
}